import * as types from './types';

const setDrillDown = (drillDown) => ({
  type: types.SET_DRILL_DOWN_STATE,
  drillDown,
});

const setSyncedAutoRefreshState = (syncedAutoRefreshState) => ({
  type: types.SET_SYNCED_AUTO_REFRESH_STATE,
  syncedAutoRefreshState,
});

export { setDrillDown, setSyncedAutoRefreshState };
